module.exports = ".autocomplete-option {\n  font-size: 1em;\n}\n\n.mat-option {\n  height: 32px !important;\n  line-height: 32px !important;\n}\n\n.loader {\n  color: #3f51b5 !important;\n}\n\n.flexbox-container {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-align: center;\n  -webkit-box-align: center;\n  align-items: center;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/argomento/argomento-search/argomento-search.component.css
// module id = ./src/app/components/argomento/argomento-search/argomento-search.component.css
// module chunks = main